var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.theme)?_c('div',{staticClass:"color-swatch",attrs:{"title":_vm.theme.name}},_vm._l((_vm.theme.colors),function(color){return _c('span',{key:color,staticClass:"color",style:({backgroundColor: color})})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }